// extracted by mini-css-extract-plugin
module.exports = {"form":"AssignToProjectForm_form__1A5Ff","tabs":"AssignToProjectForm_tabs__3jZUd","tab":"AssignToProjectForm_tab__YzQ72","active":"AssignToProjectForm_active__3UyhW"};